export default {
    path: 'partner',
    redirect: 'partner/list',
    component: () => import(/*webpackChunkName: 'partnermg-partner'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'partnermg-partner'*/ '@views/partnermg/views/partner/list.vue'),
            meta: {
                title: '渠道管理',
                topNav: true,
            },
        },
        {
            path:"detail",
            component: () => import(/*webpackChunkName: 'partnermg-partner'*/ '@views/partnermg/views/partner/detail.vue'),
            meta: {
                title: '渠道详情',
                topNav: true,
            },
        },
    ]
}